<script>
	let value = 0;
</script>

<input
	type="range"
	id="volume"
	name="volume"
	min="0"
	max="11"
	bind:value
/>
<div>
	<label for="volume">{value}</label>
</div>
